export const useSetupTrackPlayer = (): void => undefined;
